import { FieldType } from "Store/FieldManagement/PropTypes";
import { FILE_GENERATOR_TEMPLATES } from "../Helper";

interface FileGeneratorTypes {
    id: string,
    label: string,
    type: FieldType,
    optional?: boolean,
    data?: Array<{
        label: string,
        value: any,
        isDefault?: boolean
    }>
    fields?: FileGeneratorTypes[]
}

export const CooperationConditionFields: FileGeneratorTypes[] = [{
    id: 'company_name',
    label: 'Bedrijfsnaam Opdrachtgever',
    type: FieldType.Text
}, {
    id: 'length_hours',
    label: 'Duur detachering in uren',
    type: FieldType.Number
}, {
    id: 'length_months',
    label: 'Duur detachering in maanden',
    type: FieldType.Number
}, {
    id: 'length_weeks',
    label: 'Aantal werkuren per week',
    type: FieldType.Select,
    data: [
        { label: '38 werkuren', value: 38 },
        { label: '40 werkuren', value: 40, isDefault: true }
    ]
}, {
    id: 'margin_factor',
    label: 'Omrekenfactor',
    type: FieldType.Number
}, {
    id: 'adv',
    label: 'ADV Opbouw',
    type: FieldType.Toggle,
    optional: true
}, {
    id: 'payment_term',
    label: 'Betalingstermijn',
    type: FieldType.Select,
    data: [
        { label: '14 dagen', value: 14, isDefault: true},
        { label: '30 dagen', value: 30 },
        { label: '45 dagen', value: 45 },
        { label: '60 dagen', value: 60 }
    ]
}, {
    id: 'notice_period',
    label: 'Opzegtermijn',
    type: FieldType.Select,
    data: [
        { label: 'Kalendermaand', value: 1, isDefault: true },
        { label: '30 dagen', value: 30 }
    ]
}, {
    id: 'project_months',
    label: 'Duur projectopdracht in maanden',
    type: FieldType.Number
}, {
    id: 'authorized_signatory',
    label: 'Tekenbevoegde van Growing People',
    type: FieldType.Select,
    data: [
        { label: 'E. Hoefsmit', value: 1, isDefault: true },
        { label: 'J. van de Beek', value: 2 },
    ]
}, {
    id: 'authorized_signatory_client',
    label: 'Tekenbevoegde van de opdrachtgever',
    type: FieldType.Text
}];

export const TalentProposalFields: FileGeneratorTypes[] = [{
    id: 'first_name',
    label: 'Voornaam',
    type: FieldType.Text
}, {
    id: 'last_name',
    label: 'Achternaam',
    type: FieldType.Text
},
{
    id: 'date_of_birth',
    label: 'Geboortedatum',
    type: FieldType.Date,
},
{
    id: 'work_areas',
    label: 'Woonplaats',
    type: FieldType.Text
},
{
    id: 'salary',
    label: 'Salaris',
    type: FieldType.Text,
},
{
    id: 'educations',
    label: 'Opleidingsniveau',
    type: FieldType.Text,
},  {
    id: 'notice_period',
    label: 'Opzegtermijn',
    type: FieldType.Text,
},
{
    id: 'current_job',
    label: 'Huidig beroep',
    type: FieldType.Combination,
    fields: [
        { id: 'c_sector', label: 'Sector', type: FieldType.Text },
        { id: 'c_job_group', label: 'Vakgbied', type: FieldType.Text },
        { id: 'c_job_title', label: 'Functie titel', type: FieldType.Text }
    ]
}, {
    id: 'job',
    label: 'Gewenste beroepen',
    type: FieldType.Combination,
    fields: [
        { id: 'c_seniority', label: 'Senioriteit', type: FieldType.Text },
        { id: 'c_sector', label: 'Sector', type: FieldType.Text },
        { id: 'c_job_group', label: 'Vakgbied', type: FieldType.Text },
        { id: 'c_job_title', label: 'Functie titel', type: FieldType.Text }
    ]
},  {
    id: 'description_short',
    label: 'Korte beschrijving',
    type: FieldType.HTML_Editor,
},  {
    id: 'description',
    label: 'Beschrijving',
    type: FieldType.HTML_Editor,
},
{
    id: 'skills',
    label: 'Opleidingen en cursussen',
    type: FieldType.Multi_Selector,
},  {
    id: 'soft_skills',
    label: 'Soft skills',
    type: FieldType.Multi_Selector,
},  {
    id: 'hard_skills',
    label: 'Hard skills',
    type: FieldType.Multi_Selector,
},  {
    id: 'education',
    label: 'Opleidingen',
    type: FieldType.Predefined,
    optional: true
},  {
    id: 'courses',
    label: 'Cursussen',
    type: FieldType.Predefined,
    optional: true
},  {
    id: 'experience',
    label: 'Werk ervaring',
    type: FieldType.Predefined,
    optional: true
},  {
    id: 'projects',
    label: 'Projecten',
    type: FieldType.Predefined,
    optional: true
}];

export const getTemplateFieldsByTemplateId = (id: any) => {
    switch (id) {
        case FILE_GENERATOR_TEMPLATES.COOPERATION_CONDITIONS:
            return CooperationConditionFields;
        case FILE_GENERATOR_TEMPLATES.TALENT_PROPOSAL:
            return TalentProposalFields;
    }
}